import type { DrugEntity } from './entity/drugEntity';
import type { DrugIRepository } from './entity/drugIRepository';

import { DomainServiceBase } from '@/domain/domainServiceBase';

/**
 * 薬ドメインサービス
 */
export class DrugDomainService extends DomainServiceBase {
  private drugRepository!: DrugIRepository;

  /**
   * Injection
   * @param drugRepository drugRepository
   */
  public inject(
    drugRepository: DrugIRepository,
  ) {
    this.drugRepository = drugRepository;
  }

  /**
   * 薬リスト取得
   * @param token トークン
   * @returns リスト
   */
  async getDrugList(token: string | null) {
    const result = await this.drugRepository.getList(token);
    const { nextToken } = result;
    const items = result.items.map((v: DrugEntity) => v.toJson());
    return {
      /** 次のトークン */
      nextToken,
      /** 薬リスト */
      items,
    };
  }

  /**
   * 指定日の薬リスト取得
   * @param date 日付
   * @returns リスト
   */
  async getDrugListWithDate(date: string) {
    const result = await this.drugRepository.getAllListWithKey(date);
    const items = result.map((v: DrugEntity) => v.toJson());
    return items;
  }

  /**
   * 薬作成
   * @param entity 入力
   * @returns 結果
   */
  async createDrug(
    entity: DrugEntity,
  ) {
    const result = await this.drugRepository.create(entity);
    return result;
  }

  /**
   * 薬更新
   * @param entity 入力
   * @returns 結果
   */
  async updateDrug(
    entity: DrugEntity,
  ) {
    const result = await this.drugRepository.update(entity);
    return result;
  }

  /**
   * 薬削除
   * @param entity 入力
   * @returns 結果
   */
  async deleteDrug(
    entity: DrugEntity,
  ) {
    const result = await this.drugRepository.delete(entity);
    return result;
  }
}
